<div class="modal-header">
    <h4 class="modal-title pull-left">
        Résau de soin: {{itemToSave.reseau_de_soin_libelle}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col col-md-12" style="max-height: 500px; overflow-y: auto;">
                        <table class="table table-stripped table-bordered table-hover">
                            <thead>
                                <tr class="custom-table-head">
                                    <th>
                                        #
                                    </th>
                                    <th>Codification</th>
                                    <th>Libellé</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of itemsPrestatairereseauDeSoin; let indice = index">
                                    <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) +
                                        (indice+1)):indice+1 }}</td>
                                    <td>{{ item?.codification || item?.prestataire_codification}}</td>
                                    <td>{{ item?.libelle || item?.prestataire_libelle}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
    
    
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
     

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>